import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography
} from "@mui/material";

const BiliteracyWaiverDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" sx={{ zIndex: 999999999 }} fullWidth>
      <DialogTitle sx={{ fontWeight: "bold", color: "#1a237e" }}>
        Seal of Bi-literacy Agreement
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" component="div" sx={{ lineHeight: 1.7 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 1 }}>
            1. Student Performance Responsibility:
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            I understand that the Biliteracy Seal examination results are based entirely on my child’s own knowledge, preparation, and performance in the assessment.
          </Typography>

          <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 1 }}>
            2. Role of Cumming Tamil School:
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            I acknowledge that Cumming Tamil School provides guidance, instruction, and academic improvement support only. The school does not guarantee examination results, scores, or certification outcomes.
          </Typography>

          <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 1 }}>
            3. No Responsibility for Exam Results:
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            I understand and agree that Cumming Tamil School, its teachers, volunteers, and organizers are not responsible for:
            <br />• Exam failures
            <br />• Low scores
            <br />• Delays in results
            <br />• Decisions or actions taken by the external examining or certifying authorities
            <br />The Seal will be issued by the Forsyth and Gwinnett County in the school diploma/transcript.
          </Typography>

          <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 1 }}>
            4. Examination Fees:
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            I understand that:
            <br />• An examination hall fee and exam registration fee are required
            <br />• Fees must be paid as instructed
            <br />• Fees are non-refundable, unless otherwise specified by the examining authority
            <br />Since this is an exam fee it is nonrefundable.
          </Typography>

          <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 1 }}>
            5. Results Timeline:
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            I acknowledge that:
            <br />• Examination results are typically provided within 4 to 8 weeks
            <br />• The timeline may vary depending on external assessment and evaluation processes
            <br />• Cumming Tamil School does not control result processing timelines
          </Typography>

          <Typography variant="subtitle2" sx={{ fontWeight: "bold", mt: 1 }}>
            6. Parent acknowledgment:
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            I/We hereby acknowledge that both parents of the child/children have read, understood and agree to the terms and conditions mentioned in the above agreement. By checking here, you are consenting to the use of your waiver as equivalent to electronic signature and also in lieu of an original signature on paper.
          </Typography>

          <Typography variant="body2" sx={{ fontWeight: "bold", mt: 2, color: "#1a237e" }}>
            Fees structure for Biliteracy seal and 8th Grade is $275. (Separate non-refundable fees will be collected towards the end of year for examination only for Biliteracy students).
          </Typography>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" sx={{ bgcolor: "#1a237e", "&:hover": { bgcolor: "#0f172a" } }}>
          I Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BiliteracyWaiverDialog;
